import Spinner from '@/core/components/spinner'

/** 스튜디오를 처음 여는 동안의 자리 — 빈 검정 화면 대신 */
export default function StudioLoading() {
  return (
    <div
      aria-busy="true"
      className="flex min-h-full flex-col items-center justify-center gap-3 px-6 py-16 text-c14 text-description over10:text-c15"
    >
      <Spinner />
      <p>스튜디오를 여는 중…</p>
    </div>
  )
}
